import { render, staticRenderFns } from "./AppVersion.vue?vue&type=template&id=4b1dbe5e&scoped=true&"
import script from "./AppVersion.vue?vue&type=script&lang=js&"
export * from "./AppVersion.vue?vue&type=script&lang=js&"
import style0 from "./AppVersion.vue?vue&type=style&index=0&id=4b1dbe5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1dbe5e",
  null
  
)

export default component.exports